module.exports = "/packs/images/youth-education/hero@2x-5d369251dad3a0b0ee341fb5ee7467e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/youth-education/hero@2x.jpg
// module id = 1782
// module chunks = 0